// extracted by mini-css-extract-plugin
module.exports = {"title":"generic_title__qD0s9","list":"generic_list__VL3Ys","item":"generic_item__pgWO_"};